import React, { useState, useEffect } from 'react';
import { contactAPI } from '../../services/api';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import Toast from '../../components/common/Toast';

const ContactInfo = () => {
  const [contact, setContact] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', type: 'success' });

  const [formData, setFormData] = useState({
    phone: '',
    email: '',
    whatsapp: '',
    facebook_url: '',
    instagram_handle: '',
    twitter_handle: '',
    youtube_url: '',
    address: '',
    working_hours: '',
  });

  useEffect(() => {
    fetchContact();
  }, []);

  const fetchContact = async () => {
    setLoading(true);
    try {
      const response = await contactAPI.get();
      if (response.data.success) {
        const contactData = response.data.data;
        setContact(contactData);
        setFormData(contactData);
      }
    } catch (error) {
      setToast({ show: true, message: 'Failed to fetch contact info', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const response = contact 
        ? await contactAPI.update(contact.id, formData)
        : await contactAPI.create(formData);

      if (response.data.success) {
        setToast({ show: true, message: 'Contact info updated successfully', type: 'success' });
        setEditing(false);
        fetchContact();
      }
    } catch (error) {
      setToast({ show: true, message: error.response?.data?.message || 'Failed to update', type: 'error' });
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div>
      <Toast show={toast.show} message={toast.message} type={toast.type} onClose={() => setToast({ ...toast, show: false })} />
      
      <div className="page-header mb-4">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h2 className="page-title">Contact Information</h2>
            <p className="page-subtitle">Manage app contact details</p>
          </div>
          {!editing && (
            <button className="btn btn-primary" onClick={() => setEditing(true)}>
              <i className="bi bi-pencil me-2"></i>
              Edit
            </button>
          )}
        </div>
      </div>

      <div className="stat-card">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Phone</label>
              <input
                type="text"
                className="form-control"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                disabled={!editing}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Email</label>
              <input
                type="email"
                className="form-control"
                name="email"
                value={formData.email}
                onChange={handleChange}
                disabled={!editing}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">WhatsApp</label>
              <input
                type="text"
                className="form-control"
                name="whatsapp"
                value={formData.whatsapp}
                onChange={handleChange}
                disabled={!editing}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Facebook URL</label>
              <input
                type="url"
                className="form-control"
                name="facebook_url"
                value={formData.facebook_url}
                onChange={handleChange}
                disabled={!editing}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Instagram Handle</label>
              <input
                type="text"
                className="form-control"
                name="instagram_handle"
                value={formData.instagram_handle}
                onChange={handleChange}
                disabled={!editing}
                placeholder="@nisacare"
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Twitter Handle</label>
              <input
                type="text"
                className="form-control"
                name="twitter_handle"
                value={formData.twitter_handle}
                onChange={handleChange}
                disabled={!editing}
                placeholder="@nisacare"
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">YouTube URL</label>
              <input
                type="url"
                className="form-control"
                name="youtube_url"
                value={formData.youtube_url}
                onChange={handleChange}
                disabled={!editing}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Working Hours</label>
              <input
                type="text"
                className="form-control"
                name="working_hours"
                value={formData.working_hours}
                onChange={handleChange}
                disabled={!editing}
                placeholder="Mon-Fri: 9 AM - 5 PM"
              />
            </div>

            <div className="col-12 mb-3">
              <label className="form-label">Address</label>
              <textarea
                className="form-control"
                name="address"
                rows="3"
                value={formData.address}
                onChange={handleChange}
                disabled={!editing}
              ></textarea>
            </div>

            {editing && (
              <div className="col-12">
                <button type="submit" className="btn btn-primary me-2" disabled={submitting}>
                  {submitting ? 'Saving...' : 'Save Changes'}
                </button>
                <button type="button" className="btn btn-outline-secondary" onClick={() => { setEditing(false); setFormData(contact); }}>
                  Cancel
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactInfo;